import { render } from "./ActivityTimeNonFeatured.vue?vue&type=template&id=6a612a0c&ts=true"
import script from "./ActivityTimeNonFeatured.vue?vue&type=script&lang=ts"
export * from "./ActivityTimeNonFeatured.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__